import { useShortcutTarget } from '../contexts/ShortcutsContext';
import { useFocusOpen } from '../contexts/NavContext';
import { autoColor } from '../constants/shortcutTargets';

/**
 * One call wires a dialog into the shortcut system:
 *  - while `active`, the floating pin captures this exact record, and
 *  - a tile carrying `focusKey` reopens it through `onFocus`.
 *
 * Priorities: 0 main tab, 1 module sub-tab, 2 open project, 3 record
 * dialog, 4 a "new …" form (deepest wins the pin).
 */
const useDeepShortcut = ({
  active, tab, context, label, subtitle = '', icon = 'star', color, perms = [],
  priority = 3, focusKey, onFocus,
}) => {
  useShortcutTarget(
    active && label
      ? { tab, context, label: String(label), subtitle, icon, color: color || autoColor(`${tab}-${icon}`), perms }
      : null,
    priority,
  );
  useFocusOpen(focusKey || '__none__', onFocus || (() => {}));
};

export default useDeepShortcut;
